import Cookies from 'js-cookie'

const getGACookie = () => {
  return window?.Cookiebot?.consent?.statistics ? Cookies.get('_ga') : null
}

export default getGACookie
